module.exports = __webpack_public_path__ + "img/skill_intro.388def1d.png";